import ENV from '~/config/env';
// import loadExternalScript from '~/utils/loadExternalScript';
import loadCss from '~/utils/loadcss';

const loadfonts = () => {
  loadCss(ENV.UI_ASSETS_CDN_FONTS_URL);
  loadCss(`//${ENV.UI_ASSETS_CDN_URL}/ui-icons/${ENV.TRACK}/mt-ui-components/latest/styles.css`);
  loadCss(`//${ENV.UI_ASSETS_CDN_URL}/ui-icons/${ENV.TRACK}/fontawesome/latest/css/all.min.css`);
};

export const loadIcons = () => {
  loadCss(`//${ENV.UI_ASSETS_CDN_URL}/ui-icons/${ENV.TRACK}/fontawesome/latest/css/all.min.css`);
  loadCss(`//${ENV.UI_ASSETS_CDN_URL}/ui-icons/${ENV.TRACK}/mt-ui-components/latest/styles.css`);
};

export default loadfonts;
